
import * as Scrll from './funcs.js';

//* error placement =================================================== */

function validateErrorPlacement(error,element,where) {
  where = typeof where !== 'undefined' ? where : 'under';
  if (where == 'under') {
    if (element.is(':checkbox')||element.is(':radio')||element.is(':file')) {
      error.insertAfter(element.closest(".form-control"));
    } else {
      error.insertAfter(element);
    }
  } else if (where == 'label') {
    if (element.is(':checkbox')||element.is(':radio')||element.is(':file')) {
      error.appendTo(element.parent().parent('div').children('label:first-child'));
    } else {
      error.appendTo(element.parent('div').children('label'));
    }
  }
};


//* freeform setup & validation =================================================== */

$(document).ready(function(){
  if ($('.form-freeform').length) {

    // convert to html5 fieldtypes
    $('[name="phone"],[name="mobile"]').attr('type','tel');
    $('[name="email"]').attr('type','email').attr('autocapitalize','off').attr('autocorrect','off');
    $('[name="address"]').attr('autocorrect','off');
    $('[name="name"]').attr('autocorrect','off');
    $('[name="postcode"]').attr('type','number');

    // validate default
    $('.form-freeform').validate({
      ignore: ".ignore",
      onfocusout: function (element) {
        $(element).attr('data-edit', 1).valid();
      },
      onkeyup: function(element) {
        if ($(element).attr('data-edit') == '1') {
          $(element).valid();
        }
      },
      validClass: 'has-success',
      errorElement: 'p',
      errorClass: 'has-error',
      errorPlacement: function(error,element) {
        validateOpinionScale();
        validateErrorPlacement(error,element,'under'); // 'under' or 'label'
      },
      rules: {
      },
    });

    $('.form-freeform').find('input').each(function() {
      if ($(this).attr('type') == 'email') {
        $(this).rules('add', {
          email: true,
          messages: {
            email: 'Please enter a valid email address'
          }
        });
      } else if ($(this).attr('type') == 'tel') {
        $(this).rules('add', {
          regex: /^(\(?(\+61|[0-9]) ?[0-9]\)?)? ?[0-9]{2} ?[0-9]{2} ?[0-9]{1} ?[0-9]{3}$/,
          messages: {
            regex: 'Please enter a valid phone number'
          }
        });
      } else if ($(this).attr('name') == 'Postcode') {
        $(this).rules('add', {
          regex: /^[0-9]+$/,
          messages: {
            regex: 'Please enter a valid postcode'
          }
        });
      } else if ($(this).attr('type') == 'file') {
        $(this).rules('add', {
          extension: 'pdf|doc|docx|gif|png|jpg|jpeg',
          filesize: 5242880,
          messages: {
            extension: 'Please select a valid file type',
            filesize: 'File must be less than 5MB'
          }
        });
      }
      if ($(this).attr('maxlength')) {
        $(this).rules('add', {
          maxlength: $(this).attr('maxlength')
        });
      } else if ($(this).attr('name') !== 'CRAFT_CSRF_TOKEN' && $(this).attr('name') !== 'freeform_payload' && $(this).attr('name') !== 'signature') {
        $(this).rules('add', {
          maxlength: 100
        });
      }
    });

    $('.form-freeform .l_required').find('input, select, textarea').each(function() {
      console.log($(this).attr('required'));
      if ($(this).attr('required') == 'required') {
        console.log($(this));
        if ($(this).attr('type') == 'email') {
          $(this).rules('add', {
            required: true,
            email: true,
            messages: {
              // required: 'This is a required field',
              email: 'Please enter a valid email address'
            }
          });
        } else {
          $(this).rules('add', {
            required: true,
            messages: {
              // required: 'This is a required field'
            }
          });
        }
      }
    });

    $('.form-freeform [type="hidden"]').each(function() {
      if ($(this).hasClass('hiddenRecaptcha')) {
      // console.log('testing');
        $(this).rules('add', {
          required: true
        });
      }
    });

  }
});


//* form ajax submit =================================================== */

$(document).on('submit','form[data-ajax]',function(e){

  e.preventDefault();

  // init
  var $thisForm = $(this);
  var thisUrl = $thisForm.attr('action');
  var thisFormId = $thisForm.attr('id');
  var thisFormActualId = $thisForm.attr('data-id');
  var success_msg = '<h2>Form submitted</h2>';
  var success_string = $thisForm.attr('data-msg');
  var success_string_converted = $('<textarea />').html(success_string).text();
  success_msg += '<p>' + success_string_converted + '</p>';
  if (success_msg.length == 0) {
    success_msg = '<p>Thanks for getting in touch.</p>';
  }

  // generate form data
  var form_data = new FormData(document.getElementById(thisFormId));
  form_data.append($(this).attr('name'), $(this).val());

  // validate form and go
  $thisForm.validate();
  if ($thisForm.valid()) {

    // set form status to loading
    Scrll.scrollToElement($('.form-freeform'));
    $thisForm.find('input, select, textarea').attr('disabled', 'disabled');
    $thisForm.addClass('s_loading');
    $thisForm.find('.form-errors').remove();

    $.ajax({
      url: thisUrl,
      type: "post",
      data: form_data,
      cache: false,
      contentType: false,
      processData: false,
      error: function(response, textStatus, errorThrown){

        // console.log(response);
        // console.log(textStatus);
        // console.log(errorThrown);

        // remove loading status
        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.removeClass('s_loading');

        if (response.status == 400) {

          // refresh csrf token
          $.get( '/site-module/csrf/',function( data ) {
            // console.log(data);
            $('[name="' + data.csrfParam + '"]').val(data.csrfToken);
          });

          // update error message
          errorThrown = 'Expired session token has been refreshed, please retry by clicking "Submit".';

        }

        // include error
        $('.form-freeform').prepend('<div class="form-errors"><p><strong>Sorry, there was an error submitting your form. Please try again, or call if issues persist.</strong></p><p>Message: ' + errorThrown + '</p></div>');

        // scroll to top
        setTimeout(function(){
          Scrll.scrollToElement($('.form-group.has-error'));
        }, 10);

      },
      success: function(response, textStatus, jqXHR) {

        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.removeClass('s_loading');

        if (response.success && response.finished) {

          $thisForm.remove();

          $('.form-response-main').html(success_msg);
          $('.form-response').addClass('s_active');

        } else if (response.errors) {

          var hasError = false;

          for (var key in response.errors) {
            if (!response.errors.hasOwnProperty(key)) continue;
            var messages = response.errors[key];
            var $errors  = $("<p>", {"class": "has-error"});
            for (var i = 0; i < messages.length; i++) {
              var $li = $("<span>");
              $li.html(messages[i]);
              $errors.append($li);
            }

            var $input = $("*[name=" + key + "], *[name='" + key + "[]']");

            var $formGroup = $input.parents(".form-group");
            $formGroup.addClass("has-error");

            $formGroup.append($errors);

            hasError = true;

          }

          $('.form-freeform').prepend('<div class="form-errors"><p><strong>Sorry, there was an error submitting your form.</strong></p></div>');

          // scroll to top
          setTimeout(function(){
            Scrll.scrollToElement($('.form-group.has-error'));
          }, 10);

        }

      }
    });
  }

  return false;
});


//* file upload fields =================================================== */

function inputFileInit($item) {

  // init
  var $input = $item;
  var $label = $input.next( 'label' );
  var labelVal = $label.html();

  // on change input
  $input.on('change', function(e) {

    // get filename(s)
    var fileName = '';
    if (this.files && this.files.length > 1) {
      fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
    } else if( e.target.value ) {
      fileName = e.target.value.split( '\\' ).pop();
    }

    // set filename on label
    if (fileName) {
      $label.html( fileName );
    } else {
      $label.html( labelVal );
    }

  });

  // firefox bug fix
  $input.on('focus', function() {
    $input.addClass('s_focus');
  });
  $input.on('blur', function() {
    $input.removeClass('s_focus');
  });

}

function inputFileInitAll() {
  $('.file-upload').each(function() {
    inputFileInit($(this));
  });
}

$(document).ready(function(){
  inputFileInitAll();
});


//* opinion scales =================================================== */

$(document).on('click focus','.radio-scale-group input',function(){
  var $this = $(this);
  $this.parents('.radio-scale-group').addClass('s_focus');
        validateOpinionScale();
});

$(document).on('blur','.radio-scale-group input',function(){
  var $this = $(this);
  $this.parents('.radio-scale-group').removeClass('s_focus');
        validateOpinionScale();
});

function validateOpinionScale() {

  $('.radio-scale-group').each(function(){
    if ($(this).find('.has-success').length > 0) {
      $(this).addClass('has-success');
    } else {
      $(this).removeClass('has-success');
    }
    if ($(this).find('.has-error').length > 0) {
      $(this).addClass('has-error');
    } else {
      $(this).removeClass('has-error');
    }
  });

}


//* clinic and service relationship =================================================== */

$(document).on('change','#form-input-service',function(){
  var serviceId = $(this).find('option:selected').attr('data-id');
  if (serviceId) {
    $('#form-input-branch').find('option').remove();
    $('#form-input-branch').append('<option value="" data-id="" data-slug="" data-services="">Please select...</option>');
    $('#branch-placeholder option').each(function(){
      if ($(this).attr('data-services').indexOf('|' + serviceId + '|') !== -1) {
        // $(this).removeAttr('disabled');
        var $option = $(this).clone();
        $('#form-input-branch').append($option);
      } else {
        // $(this).attr('disabled', 'disabled');
      }
    });
  }
});


//* clinic pre select =================================================== */

if ($('#form-input-branch').length) {
  var clinicSlug = document.location.hash.substr(1);
  if (clinicSlug.length) {
    var clinicVal = $('#form-input-branch [data-slug="' + clinicSlug + '"]').val();
    $('#form-input-branch').val(clinicVal);
    clinicSnapshot();
  }
}


//* clinic preview =================================================== */

function clinicSnapshot() {

  var clinicId = $('#form-input-branch').find('option:selected').attr('data-id');
  // console.log(clinicId);

  $('.clinicsnapshot').removeClass('s_active');
  $('.clinicsnapshot[data-id="' + clinicId + '"]').addClass('s_active');

}

$(document).on('change','#form-input-branch',function(){
  clinicSnapshot();
});


//* full name =================================================== */

$(document).on('change keyup','[name="firstName"], [name="lastName"]',function(){
  $('[name="fullName"]').val($('[name="firstName"]').val() + ' ' + $('[name="lastName"]').val());
});


//* conditional fields =================================================== */

$(document).ready(function(){

  $('.conditionalGroup').each(function(){

    $(this).hide();
    $(this).find('input:not(.datefield-input), select, textarea').addClass('ignore');

    var fieldId = $(this).attr('data-condid');

    $('#form-group-' + fieldId).addClass('conditionalTrigger');
    $('#form-group-' + fieldId).attr('data-id', fieldId);

  });

});

function conditionalTrigger(fieldId, fieldVal) {

  $('[data-condid="' + fieldId + '"]').each(function(){
    
    var condType = $(this).attr('data-condtype');
    var condMatches = false;
    
    if (condType == 'in') {
      condMatches = fieldVal.search($(this).attr('data-condval')) !== -1;
    } else {
      condMatches = $(this).attr('data-condval') == fieldVal
    }

    if (condMatches) {
      if (condType == 'title') {
        $(this).find('label').text($(this).attr('data-condtitle'));
        $(this).show();
        $(this).addClass('l_required').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').rules('add', 'required');
      } else {
        $(this).show();
        $(this).addClass('l_required').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').rules('add', 'required');
      }
    } else {
      if (condType == 'title') {
        $(this).find('label').text($(this).attr('data-origtitle'));
        $(this).show();
        $(this).addClass('l_required').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').removeClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').rules('add', 'required');
      } else {
        $(this).hide();
        $(this).removeClass('l_required').addClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').addClass('ignore');
        $(this).find('input:not(.datefield-input), select, textarea').rules('remove', 'required');
      }
    }

  });

}

$(document).on('change','.conditionalTrigger input',function(){

  var fieldId = $(this).parents('.form-group').attr('data-id');
  var fieldVal = $(this).val();
  var fieldName = $(this).attr('name');
  
  if ($(this).attr('type') == 'checkbox') {
    fieldVal = '';
    var sep = '';
    $('input:checkbox[name="' + fieldName + '"]:checked').each(function(){
      fieldVal = fieldVal + sep + $(this).val();
      sep = ',';
    });
  }
  
  conditionalTrigger(fieldId, fieldVal);

});

$(document).ready(function(){

  $('.conditionalTrigger input:checked').each(function(){
    conditionalTrigger($(this).parents('.form-group').attr('data-id'), $(this).val());
  });


});


//* date of birth =================================================== */

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

function updateDateOfBirth($dateField) {

  var d = $dateField.find('.datefield-d').val();
  var m = $dateField.find('.datefield-m').val();
  var y = $dateField.find('.datefield-y').val();

  if (d.length == 2 && m.length == 2 && y.length == 4) {
    var dateOfBirth = $dateField.find('.datefield-d').val() + '/' + $dateField.find('.datefield-m').val() + '/' + $dateField.find('.datefield-y').val();
    $dateField.find('.datefield-actualinput').val(dateOfBirth);
    $dateField.find('.datefield-actualinput').valid();
  } else {
    $dateField.find('.datefield-actualinput').val('');
    $dateField.find('.datefield-actualinput').attr('data-edit', '');
    if ($dateField.find('.datefield-d').attr('data-edit') == '1' && $dateField.find('.datefield-m').attr('data-edit') == '1' && $dateField.find('.datefield-y').attr('data-edit') == '1') {
      $dateField.find('.datefield-actualinput').attr('data-edit', 1);
      $dateField.find('.datefield-actualinput').valid();
    }
  }

}

$(document).ready(function(){

  $('.datefield-actualinput').hide();

  $('.datefield-actualinput').rules('add', {
    regex: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
    messages: {
      // required: 'This is a required field',
      regex: 'Please enter a valid date'
    }
  });

});

var dateFieldFirstTouch = false;
$(document).on('click focus','.datefield-input',function(){

  $(this).attr('data-touch', '');

  if (!dateFieldFirstTouch) {
    dateFieldFirstTouch = true;
    $(this).find('.datefield-d').focus();
  }

});

$(document).on('keyup','.datefield-input',function(e){

  var $dateField = $(this).parents('.datefield-group');

  // Prevent shift key since its not needed
  if (e.shiftKey == true) {
      e.preventDefault();
  }

  // console.log('here');
  // console.log(e.keyCode);

  // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
  if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 37 || e.keyCode == 39 || e.keyCode == 46) {

    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {

      var maxChars = parseFloat($(this).attr('maxlength'));
      var min = parseFloat($(this).attr('min'));
      var max = parseFloat($(this).attr('max'));

      // console.log($(this).attr('data-touch'));

      // console.log(maxChars);

      $(this).attr('data-touch', 1);

      if ($(this).hasClass('datefield-d')) {
        if ($(this).val().length == 1 && $(this).val() > 3) {
          $(this).val(pad($(this).val(), 2));
          $(this).nextAll('input').first().focus().select();
        }
      }

      if ($(this).hasClass('datefield-m')) {
        if ($(this).val().length == 1 && $(this).val() > 1) {
          $(this).val(pad($(this).val(), 2));
          $(this).nextAll('input').first().focus().select();
        }
      }

      if ($(this).attr('data-touch') == 1 && $(this).val().length >= maxChars) {
        $(this).nextAll('input').first().focus().select();
      }

    }

  } else {
    e.preventDefault();
  }

  updateDateOfBirth($dateField);

});

$(document).on('blur','.datefield-input',function(){

  var $dateField = $(this).parents('.datefield-group');

  if ($(this).val().length) {

    var maxChars = parseFloat($(this).attr('maxlength'));
    var min = parseFloat($(this).attr('min'));
    var max = parseFloat($(this).attr('max'));

    if ($(this).val() < min) {
      $(this).val(min);
    }

    if ($(this).val() > max) {
      $(this).val(max);
    }

    if ($(this).hasClass('datefield-d') || $(this).hasClass('datefield-m')) {
      $(this).val(pad($(this).val(), 2));
    }

  }

  $(this).attr('data-edit', 1);

  updateDateOfBirth($dateField);


});

$(document).on('click focus','.datefield input',function(){
  var $this = $(this);
  $this.parents('.datefield').addClass('s_focus');
  validatedatefield();
});

$(document).on('blur','.datefield input',function(){
  var $this = $(this);
  $this.parents('.datefield').removeClass('s_focus');
  validatedatefield();
});

function validatedatefield() {

  $('.datefield-group').each(function(){
    if ($(this).find('.has-success').length > 0) {
      $(this).find('.datefield').addClass('has-success');
    } else {
      $(this).find('.datefield').removeClass('has-success');
    }
    if ($(this).find('.has-error').length > 0) {
      $(this).find('.datefield').addClass('has-error');
    } else {
      $(this).find('.datefield').removeClass('has-error');
    }
  });

}


//* collections =================================================== */

// config
var collections = {};
var qualifications = [
  'Allergy',
  'Anaesthetics',
  'Audiology',
  'Cardiology',
  'Chiropractor',
  'Cranio Facial Surgery',
  'Colorectal Surgeon',
  'Dentistry',
  'Dermatology',
  'Endocrinology',
  'Endodontistry',
  'Ent Surgery',
  'Gastroenterology',
  'Genetics',
  'General Medicine / Physician',
  'General Prac W Dip Obs',
  'General Practitioner - Locum',
  'General Practitioner',
  'General Practitioner - Registrar',
  'General Surgery',
  'Geriatrics',
  'Haematology',
  'Hospital Emo',
  'Hospital Registrar',
  'Hospital RMO',
  'Hospital SMO',
  'Hospital Ward',
  'Immunology',
  'Infectious Diseases',
  'Intensive Care',
  'Maxillo-facial Surgery',
  'Midwife',
  'Nephrology',
  'Neurology',
  'Neurosurgery',
  'Nurse Practitioner',
  'Obstetrics & Gynaecology',
  'Occupational Therapy',
  'Occupational Physician',
  'Oncology',
  'Ophthalmology',
  'Orthodontistry',
  'Orthopaedics',
  'Osteopath',
  'Paediatric Dentistry',
  'Paediatric Surgery',
  'Paediatrics',
  'Pain Specialist',
  'Palliative Care',
  'Pathology',
  'Periodontistry',
  'Physiotherapy',
  'Plastic Surgery',
  'Podiatry',
  'Prosthodontistry',
  'Psychiatry',
  'Radiation Oncology',
  'Radiology',
  'Rehabilitation',
  'Renal Physician',
  'Rheumatology',
  'Sports Physician',
  'Thoracic Medicine',
  'Trials',
  'Urology',
  'Vascular'
];

// mri safety - surgery details
collections['surgeryDetails'] = {
  itemTitle: 'Surgery Details',
  itemName: 'surgery',
  count: 1,
  max: 20,
  incrementalCount: 0,
  min: 1,
  fields : [
    {
      type: 'text',
      name: 'Type of surgery'
    },
    {
      type: 'text',
      name: 'Approximate date'
    },
    {
      type: 'text',
      name: 'Surgeon'
    },
    {
      type: 'text',
      name: 'Hospital'
    }
  ],
};

// future employment reg - referees
collections['referees'] = {
  itemTitle: 'Referee',
  itemName: 'referee',
  count: 2,
  incrementalCount: 0,
  min: 2,
  max: 2,
  fields : [
    {
      type: 'text',
      name: 'Full Name'
    },
    {
      type: 'text',
      name: 'Organisation',
      class: 'col-6'
    },
    {
      type: 'text',
      name: 'Position',
      class: 'col-6'
    },
    {
      type: 'tel',
      name: 'Phone',
      class: 'col-6'
    },
    {
      type: 'email',
      name: 'Email',
      class: 'col-6'
    }
  ],
};

// benson account request - clinicians
collections['clinicians'] = {
  itemTitle: 'Clinician details',
  itemName: 'clinician',
  count: 1,
  incrementalCount: 0,
  min: 1,
  max: 20,
  fields : [
    {
      type: 'text',
      name: 'Name'
    },
    {
      type: 'email',
      name: 'Email'
    },
    {
      type: 'tel',
      name: 'Mobile',
      required: false,
      instructions: 'We value your privacy and want to assure you that your mobile number will not be used for any mailing lists or unsolicited communications. It will be used for account verification only.'
    },
    {
      type: 'textarea',
      name: 'Provider Number and Address',
      instructions: 'If multiple locations, please enter each provider number and address on a new line'
    },
    {
      type: 'select',
      name: 'Qualification',
      options: qualifications,
    },
    {
      type: 'checkboxes',
      name: 'Film Preferences',
      options: [
        'Film free',
        'Download to clinical software',
        'Hard copy films',
      ],
    },
    // {
    //   type: 'select',
    //   name: 'Request Forms',
    //   options: [
    //     'Personalised A5 Request Forms',
    //     'Computerised A4 Request Forms',
    //     'No Request Forms Required'
    //   ],
    // },
    {
      type: 'checkbox',
      name: 'Terms and Confidentiality Agreement accepted',
      instructions: '<a href="/benson-connect/terms-and-confidentiality-agreement/" target="_blank">Please read the terms and confidentiality agreement here</a>'
    },
  ],
};

// benson account request [public] - clinicians
collections['publicClinicians'] = {
  itemTitle: 'Clinician details',
  itemName: 'clinician',
  count: 1,
  incrementalCount: 0,
  min: 1,
  max: 20,
  fields : [
    {
      type: 'text',
      name: 'First Name'
    },
    {
      type: 'text',
      name: 'Last Name'
    },
    {
      type: 'email',
      name: 'SA Gov Email'
    },
    {
      type: 'tel',
      name: 'Mobile',
      required: false,
      instructions: 'We value your privacy and want to assure you that your mobile number will not be used for any mailing lists or unsolicited communications. It will be used for account verification only.'
    },
    {
      type: 'textarea',
      name: 'Provider Number and AHPRA number',
      instructions: 'If multiple locations, please enter each provider number and address on a new line'
    },
    {
      type: 'select',
      name: 'Qualification',
      options: qualifications,
    },
    {
      type: 'checkboxes',
      name: 'Film Preferences',
      options: [
        'Film free',
        'Download to clinical software',
        'Hard copy films',
      ],
    },
    // {
    //   type: 'select',
    //   name: 'Request Forms',
    //   options: [
    //     'Personalised A5 Request Forms',
    //     'Computerised A4 Request Forms',
    //     'No Request Forms Required'
    //   ],
    // },
    {
      type: 'checkbox',
      name: 'Terms and Confidentiality Agreement accepted',
      instructions: '<a href="/benson-connect/terms-and-confidentiality-agreement/" target="_blank">Please read the terms and confidentiality agreement here</a>'
    },
  ],
};

// benson account new doctors - practitioners
collections['practitioners'] = {
  itemTitle: 'Practitioner details',
  itemName: 'practitioner',
  count: 1,
  incrementalCount: 0,
  min: 1,
  max: 20,
  fields : [
    {
      type: 'text',
      name: 'Title',
      class: 'col-4'
    },
    {
      type: 'text',
      name: 'First Name'
    },
    {
      type: 'text',
      name: 'Last Name'
    },
    {
      type: 'email',
      name: 'Email'
    },
    {
      type: 'tel',
      name: 'Mobile',
      required: false,
      instructions: 'We value your privacy and want to assure you that your mobile number will not be used for any mailing lists or unsolicited communications. It will be used for account verification only.'
    },
    {
      type: 'textarea',
      name: 'Provider Number and Address',
      instructions: 'If multiple locations, please enter each provider number and address on a new line'
    },
    {
      type: 'select',
      name: 'Qualification',
      options: qualifications,
    },
    {
      type: 'checkboxes',
      name: 'Film Preferences',
      options: [
        'Film free',
        'Benson Connect',
        // 'By checking this box you agree to the Terms and Confidentiality Agreement',
        'Download to clinical software',
        'Hard copy films',
      ],
    },
    // {
    //   type: 'select',
    //   name: 'Request Forms',
    //   options: [
    //     'Personalised A5 Request Forms',
    //     'Computerised A4 Request Forms',
    //     'No Request Forms Required'
    //   ],
    // },
  ],
};

// order request forms - pads
collections['requestPads'] = {
  itemTitle: 'Request Pad Order',
  itemName: 'another order',
  count: 1,
  incrementalCount: 0,
  min: 1,
  max: 20,
  fields : [
    {
      type: 'select',
      name: 'Type',
      options: [
        'General Imaging (A4)',
        'General Imaging (A5)',
        'Dental Imaging (A5)',
        'Chiropractor Imaging (A5)',
        'PET Imaging (A4)',
        'Urology Imaging (A5)',
        'Urology Imaging (A4)',
      ],
      toggleTriggerId: 'type',
      toggleTrigger: true
    },
    {
      type: 'select',
      name: 'Quantity',
      options: [
        '2',
        '4',
        '6',
        '8',
        '10',
        'Other',
      ],
      instructions: 'Please note there are 100 referrals per pad',
      toggleTriggerId: 'quantity',
      toggleTrigger: true
    },
    {
      type: 'text',
      name: 'Quantity (Other)',
      toggleId: 'quantity',
      toggle: 'Other'
    },
    {
      type: 'scale',
      options: [
        'Yes',
        'No'
      ],
      name: 'Would you like them personalised with the practitioner\'s contact details?',
      toggleTriggerId: 'personalised',
      toggleTrigger: true,
      toggleId: 'type',
      toggle: 'A5'
    },
    {
      type: 'text',
      name: 'Practitioner Title',
      toggleId: 'personalised',
      toggle: 'Yes'
    },
    {
      type: 'text',
      name: 'Practitioner First Name',
      toggleId: 'personalised',
      toggle: 'Yes'
    },
    {
      type: 'text',
      name: 'Practitioner Last Name',
      toggleId: 'personalised',
      toggle: 'Yes'
    },
    {
      type: 'text',
      name: 'Practitioner Provider Number',
      toggleId: 'personalised',
      toggle: 'Yes'
    },
    {
      type: 'select',
      name: 'Practitioner Qualification',
      options: qualifications,
      toggleId: 'personalised',
      toggle: 'Yes'
    }
  ],
};

// loop through all collections and initiate
const collectionsObject = Object.entries(collections)
for (const [colKey, colData] of collectionsObject) {

  // init collection keys
  var collectionId = colKey;
  var collectionData = colData;

  // only do this if the field exists on this page
  if ($('[name="' + collectionId + '"]').length > 0) {

    // start building the html
    var collectionHtml = '<div class="collection s_active" data-id="COL_ID">';
    collectionHtml += '<div class="collection-summary"><div class="collection-head" data-action="collectionToggle"><button class="collection-toggle"><svg class="icon"><use href="#chevron-down"></use></svg></button><div class="collection-title" data-id="title">' + collectionData['itemTitle'] + ' COL_ID</div></div><button class="collection-remove" data-action="collectionRemove"><svg class="icon"><use href="#cross"></use></svg></button></div>';
    collectionHtml += '<div class="collection-edit">';

    // mark the field and hide it
    $('[name="' + collectionId + '"]').attr('data-collection', 1);
    $('[name="' + collectionId + '"]').addClass('l_collection');

    // loop through fields and build the html
    const fields = Object.entries(collectionData['fields']);
    for (const [fieldKey, fieldData] of fields) {

      // setup toggle
      var toggleId = '';
      var toggle = '';
      var toggleTriggerId = '';
      var toggleTrigger = '';
      var displayInit = '';
      var inputClassInit = '';
      if (typeof fieldData['toggle'] !== 'undefined') {
        toggle = fieldData['toggle'];
        displayInit = 'style="display:none;"';
        inputClassInit = 'ignore';
      }
      if (typeof fieldData['toggleTrigger'] !== 'undefined') {
        toggleTrigger = 1;
      }
      if (typeof fieldData['toggleTriggerId'] !== 'undefined') {
        toggleTriggerId = fieldData['toggleTriggerId'];
      }
      if (typeof fieldData['toggleId'] !== 'undefined') {
        toggleId = fieldData['toggleId'];
      }

      // set form class
      var groupClass = '';
      if (typeof fieldData['class'] !== 'undefined') {
        groupClass = ' ' + fieldData['class'];
      }

      // set required attribute
      var isRequired = true;
      var requiredAttribute = 'required';
      if (typeof fieldData['required'] !== 'undefined') {
        // console.log(fieldData['required']);
        isRequired = fieldData['required'];
        requiredAttribute = fieldData['required'] ? 'required' : '';
      }
      if (isRequired) groupClass += ' l_required';

      collectionHtml += '<div class="form-group ' + groupClass + '" ' + displayInit
      if (toggle.length) collectionHtml += ' data-toggle="' + toggle + '"';
      if (toggleId.length) collectionHtml += ' data-toggleId="' + toggleId + '"';
      if (toggleTrigger) collectionHtml += ' data-toggleTrigger="' + toggleTrigger + '"';
      if (toggleTriggerId.length) collectionHtml += ' data-toggleTriggerId="' + toggleTriggerId + '"';
      collectionHtml += '>';
      collectionHtml += '<label for="">' + fieldData['name'] + '</label>';
      if (typeof fieldData['instructions'] !== 'undefined') {
        collectionHtml += '<div class="help-block l_small">' + fieldData['instructions'] + '</div>';
      }

      collectionHtml += '<div class="form-control">';

      // set input attributes
      var inputAttributes = '';
      if (fieldData['type'] == 'email') {
        inputAttributes = 'autocapitalize="off" autocorrect="off"';
      }

      if (fieldData['type'] == 'text' || fieldData['type'] == 'tel' || fieldData['type'] == 'email') {
        collectionHtml += '<input type="' + fieldData['type'] + '" name="' + collectionId + '_' + fieldKey + '_COL_ID" value="" data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' ' + inputAttributes + ' class="' + inputClassInit + '">';

      } else if (fieldData['type'] == 'textarea') {
        collectionHtml += '<textarea name="' + collectionId + '_' + fieldKey + '_COL_ID"  data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' class="' + inputClassInit + '"></textarea>';

      } else if (fieldData['type'] == 'select') {
        collectionHtml += '<select name="' + collectionId + '_' + fieldKey + '_COL_ID" data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' class="' + inputClassInit + '">';
        collectionHtml += '<option value="">Please select...</option>';
        const selectOptions = Object.entries(fieldData['options']);
        for (const [optKey, optLabel] of selectOptions) {
          collectionHtml += '<option value="' + optLabel + '">' + optLabel + '</option>';
        }
        collectionHtml += '</select>';

      } else if (fieldData['type'] == 'checkbox') {
        collectionHtml += '<div class="checkbox-stacked styledcheckbox">';
        collectionHtml += '<input type="checkbox" name="' + collectionId + '_' + fieldKey + '_COL_ID" id="' + collectionId + '_' + fieldKey + '_COL_ID" value="Yes" class="l_first ' + inputClassInit + '" data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' ' + inputAttributes + '>';
        collectionHtml += '<label for="' + collectionId + '_' + fieldKey + '_COL_ID" class="checkbox-value">Yes</label>';
        collectionHtml += '</div>';

      } else if (fieldData['type'] == 'checkboxes') {
        collectionHtml += '<div class="form-control">';
        const selectOptions = Object.entries(fieldData['options']);
        for (const [optKey, optLabel] of selectOptions) {

          // special instructions for benson connect one
          var optLabelNew = optLabel;
          if (optLabel == 'Benson Connect') {
            optLabelNew = 'Benson Connect<br /><span style="display: block; font-size: 11px; margin-left: 37px; line-height: 1.3;">By checking this box you agree to the <a href="/benson-connect/terms-and-confidentiality-agreement/">Terms and Confidentiality Agreement</a></span>';
          }

          // add class to first
          inputAttributes = '';
          if (optKey == 0) {
            inputAttributes = 'class="l_first"';
          }

          collectionHtml += '<div class="checkbox-stacked styledcheckbox">';
          collectionHtml += '<input type="checkbox" name="' + collectionId + '_' + fieldKey + '_COL_ID[]" id="' + collectionId + '_' + fieldKey + '_COL_ID_' + optKey + '"  value="' + optLabel + '" data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' ' + inputAttributes + ' class="' + inputClassInit + '">';
          collectionHtml += '<label for="' + collectionId + '_' + fieldKey + '_COL_ID_' + optKey + '" class="checkbox-value">' + optLabelNew + '</label>';
          collectionHtml += '</div>';
        }
        collectionHtml += '</div>';
      } else if (fieldData['type'] == 'scale') {
        collectionHtml += '<div class="radio-scale-group">';
        const selectOptions = Object.entries(fieldData['options']);
        for (const [optKey, optLabel] of selectOptions) {

          // add class to first
          inputAttributes = '';
          if (optKey == 0) {
            inputAttributes = 'class="l_first"';
          }
          
          collectionHtml += '<div class="radio-scale">';
          collectionHtml += '<input type="radio" name="' + collectionId + '_' + fieldKey + '_COL_ID" id="' + collectionId + '_' + fieldKey + '_COL_ID_' + optKey + '"  value="' + optLabel + '" data-label="' + fieldData['name'] + '" ' + requiredAttribute + ' ' + inputAttributes + ' class="' + inputClassInit + '">';
          collectionHtml += '<label for="' + collectionId + '_' + fieldKey + '_COL_ID_' + optKey + '" class="checkbox-value">' + optLabel + '</label>';
          collectionHtml += '</div>';
        }
        collectionHtml += '</div>';
      }

      collectionHtml += '</div></div>';

    }

    collectionHtml += '</div>';
    collectionHtml += '</div>';

    // add in collections box and controls
    $('[name="' + collectionId + '"]').after('<div class="collections" data-id="' + collectionId + '"></div><div class="collections-controls"><button class="btn l_filled l_min" data-action="collectionAdd" data-id="' + collectionId + '">Add ' + collectionData['itemName'] + '</button></div>');
    collections[collectionId]['html'] = collectionHtml;

    // create the collection
    var initialCount = collectionData['count'];
    for (var i=1; i<=initialCount; i++) {
      // console.log(i);
      collectionCreate(collectionId);
    }
    collectionOpenAll(collectionId);

  }

};

function collectionCount(collectionId) {

  // update total with a real count of dom elements
  var total = $('.collections[data-id="' + collectionId + '"] .collection').length;
  collections[collectionId]['count'] = total;

  // show/hide remove buttons if count < min
  if (collections[collectionId]['count'] <= collections[collectionId]['min']) {
    $('.collections[data-id="' + collectionId + '"]').addClass('l_min');
  } else {
    $('.collections[data-id="' + collectionId + '"]').removeClass('l_min');
  }

  // show/hide remove buttons if count < min
  // console.log(collections[collectionId]['count']);
  // console.log(collections[collectionId]['max']);
  if (collections[collectionId]['count'] >= collections[collectionId]['max']) {
    $('.collections-controls').hide();
    // console.log('max');
  } else {
    $('.collections-controls').show();
    // console.log('nomax');
  }

  return total;

}

function collectionCreate(collectionId) {

  // close all other collections
  collectionCloseAll(collectionId);

  // increment the global id count
  collections[collectionId]['incrementalCount'] ++;

  // generate the html and append it
  var colHtml = collections[collectionId]['html'];
  colHtml = colHtml.replace(/COL_ID/gi, collections[collectionId]['incrementalCount']);
  $('.collections[data-id="' + collectionId + '"]').append(colHtml);

  // count and write
  collectionCount(collectionId);
  collectionWrite(collectionId);

}

function collectionRemove(collectionId, itemId) {

  // only remove if above the minimum
  if (collections[collectionId]['count'] > collections[collectionId]['min']) {

    $('.collections[data-id="' + collectionId + '"] .collection[data-id="' + itemId + '"]').remove();
    collectionCount(collectionId);
  }

}

function collectionCloseAll(collectionId) {

  $('.collections[data-id="' + collectionId + '"] .collection').removeClass('s_active');

}

function collectionOpenAll(collectionId) {

  $('.collections[data-id="' + collectionId + '"] .collection').addClass('s_active');

}

function collectionWrite(collectionId) {

  // init
  var collectionText = '';
  var newLine = '';

  // loop through every item in the collection
  $('.collections[data-id="' + collectionId + '"] .collection').each(function() {

    collectionText += newLine;
    newLine = '\n--------\n';

    var sep = '';
    var valSep = ', ';
    var processedInputs = new Array();

    $(this).find('input, select, textarea').each(function() {
      
      if (!$(this).hasClass('ignore')) {

        if ($(this).attr('type') == 'checkbox') {
          // console.log(processedInputs);
          // console.log($(this).attr('name'));
          // console.log(processedInputs.indexOf($(this).attr('name')));
          var labelText = '';
          var fieldText = '';
          if ($(this).hasClass('l_first') || processedInputs.indexOf($(this).attr('name')) == -1) {
            labelText += sep;
            sep = '\n';
            labelText += '<strong>' + $(this).attr('data-label') + ':</strong> ';
            valSep = '';
          }
          if ($(this).is(':checked')) {
            fieldText += valSep + $(this).val();
            valSep = ', ';
            processedInputs.push($(this).attr('name'));
          }
          if (fieldText.length) {
            collectionText += labelText + fieldText;
          }
        } else if ($(this).attr('type') == 'radio') {
          var labelText = '';
          var fieldText = '';
          labelText += sep;
          sep = '\n';
          labelText += '<strong>' + $(this).attr('data-label') + ':</strong> ';
          valSep = '';
          if ($(this).is(':checked')) {
            fieldText += valSep + $(this).val();
            valSep = ', ';
            processedInputs.push($(this).attr('name'));
          }
          if (fieldText.length) {
            collectionText += labelText + fieldText;
          }
        } else {
          if ($(this).val().length) {
            collectionText += sep;
            sep = '\n';
            collectionText += '<strong>' + $(this).attr('data-label') + ':</strong> ' + $(this).val();
            processedInputs.push($(this).attr('name'));
          }
        }
        
      }

    });

  });

  // remove unwanted characters and set field value
  collectionText = collectionText.replace(/<strong>/g,'||strong||');
  collectionText = collectionText.replace(/<\/strong>/g,'||endstrong||');
  collectionText = collectionText.replace(/<[^>]*>/g," ");
  collectionText = collectionText.replace(/\|\|strong\|\|/g,'<strong>');
  collectionText = collectionText.replace(/\|\|endstrong\|\|/g,'</strong>');
  $('[name="' + collectionId + '"]').val(collectionText);

}

// action: toggle collection
$(document).on('click','[data-action="collectionToggle"]',function(){
  $(this).parents('.collection').toggleClass('s_active');
  return false;
});

// action: remove collection
$(document).on('click','[data-action="collectionRemove"]',function(){
  var collectionId = $(this).parents('.collections').attr('data-id');
  var itemId = $(this).parents('.collection').attr('data-id');
  collectionRemove(collectionId, itemId);
  return false;
});

// action: add collection
$(document).on('click','[data-action="collectionAdd"]',function(){
  var collectionId = $(this).attr('data-id');
  collectionCreate(collectionId);
  return false;
});

// action: write on change
$(document).on('click change keyup','.collection input, .collection select, .collection textarea',function(){
  var collectionId = $(this).parents('.collections').attr('data-id');
  collectionWrite(collectionId);
});

// toggles and triggers
$(document).on('change', '[data-toggleTrigger="1"] input, [data-toggleTrigger="1"] select',function(){
  var $collection = $(this).parents('.collection');
  var theVal = $(this).val();
  var toggleId = $(this).parents('.form-group').attr('data-toggleTriggerId');
  $collection.find('[data-toggleId="' + toggleId + '"]').each(function(){
    var toggleMatch = $(this).attr('data-toggle').toString();
    if (theVal.indexOf(toggleMatch) !== -1) {
      $(this).show();
      $(this).find('input, select').removeClass('ignore');
    } else {
      $(this).hide();
      $(this).find('input, select').addClass('ignore');
      // if it's an "other" input, clear it
      var label = $(this).find('input').attr('data-label') ?? null
      if (label && label.search('(Other)') !== -1) {
        $(this).find('input').val('');
      } else if (label && label.search('Would you like them personalised') !== -1) {
        $(this).find('input[value="Yes"]').attr('checked', false).change();
        $(this).find('input[value="No"]').attr('checked', true).change();
      }
    }
  });
});


//* recaptcha =================================================== */

if (typeof grecaptcha !== 'undefined') {
  grecaptcha.ready(function() {
    $('.form-freeform [type="submit"]').attr('disabled', true);
    grecaptcha.execute(recaptchaSiteKey, {action: 'submit'}).then(function(token) {
      // console.log(token);
      $.post('/revalidate.php', {token: token}, function(result) {
        // console.log(result);
        if (result.success == 'true') {
          $('.form-freeform [type="submit"]').attr('disabled', false);
        } else {
          $('.form-freeform').before('<p>Error verifying reCAPTCHA. Please <a href="/contact/">contact us</a> if you believe this is an error.</p>');
          $('.form-freeform').remove();
        }
      });
    });
  });
}



//* signature =================================================== */

(function() {
  window.requestAnimFrame = (function(callback) {
    return window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimaitonFrame ||
      function(callback) {
        window.setTimeout(callback, 1000 / 60);
      };
  })();

  var canvas = document.getElementById("form-input-signature");
  if (canvas) {
    var ctx = canvas.getContext("2d");
    ctx.strokeStyle = canvas.getAttribute('data-pen-color') ?? "#222222";
    ctx.lineWidth = canvas.getAttribute('data-dot-size') ?? 4;

    var drawing = false;
    var mousePos = {
      x: 0,
      y: 0
    };
    var lastPos = mousePos;

    canvas.addEventListener("mousedown", function(e) {
      drawing = true;
      lastPos = getMousePos(canvas, e);
    }, false);

    canvas.addEventListener("mouseup", function(e) {
      drawing = false;
    }, false);

    canvas.addEventListener("mousemove", function(e) {
      mousePos = getMousePos(canvas, e);
    }, false);

    // Add touch event support for mobile
    canvas.addEventListener("touchstart", function(e) {

    }, false);

    canvas.addEventListener("touchmove", function(e) {
      var touch = e.touches[0];
      var me = new MouseEvent("mousemove", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.dispatchEvent(me);
    }, false);

    canvas.addEventListener("touchstart", function(e) {
      mousePos = getTouchPos(canvas, e);
      var touch = e.touches[0];
      var me = new MouseEvent("mousedown", {
        clientX: touch.clientX,
        clientY: touch.clientY
      });
      canvas.dispatchEvent(me);
    }, false);

    canvas.addEventListener("touchend", function(e) {
      var me = new MouseEvent("mouseup", {});
      canvas.dispatchEvent(me);
    }, false);

    function getMousePos(canvasDom, mouseEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: mouseEvent.clientX - rect.left,
        y: mouseEvent.clientY - rect.top
      }
    }

    function getTouchPos(canvasDom, touchEvent) {
      var rect = canvasDom.getBoundingClientRect();
      return {
        x: touchEvent.touches[0].clientX - rect.left,
        y: touchEvent.touches[0].clientY - rect.top
      }
    }

    function renderCanvas() {
      if (drawing) {
        ctx.moveTo(lastPos.x, lastPos.y);
        ctx.lineTo(mousePos.x, mousePos.y);
        ctx.stroke();
        lastPos = mousePos;
      }
    }

    // Prevent scrolling when touching the canvas
    document.body.addEventListener("touchstart", function(e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);
    document.body.addEventListener("touchend", function(e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);
    document.body.addEventListener("touchmove", function(e) {
      if (e.target == canvas) {
        e.preventDefault();
      }
    }, false);

    (function drawLoop() {
      requestAnimFrame(drawLoop);
      renderCanvas();
    })();

    function clearCanvas() {
      canvas.width = canvas.width;
      var ctx = canvas.getContext("2d");
      ctx.strokeStyle = canvas.getAttribute('data-pen-color') ?? "#222222";
      ctx.lineWidth = canvas.getAttribute('data-dot-size') ?? 4;
    }

    // Set up the UI
    var sigText = document.querySelector('[name="signature"]');
    var clearBtn = document.querySelector("[data-signature-clear]");
    clearBtn.addEventListener("click", function(e) {
      clearCanvas();
      sigText.value = '';
    }, false); 
    canvas.addEventListener("mousemove", function(e) {
      var dataUrl = canvas.toDataURL();
      sigText.value = dataUrl;
    }, false);

  }

})();